import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { useNotifications } from '@toolpad/core';
import { format } from 'date-fns';
import { useForm } from 'react-hook-form';
// import { Api, Notes } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { BusinessSignup, BusinessSignupNote, User } from '@barboxx/models';

import { NOTES_SCHEMA, NotesForm } from './NotesForm';

const columns: GridColDef[] = [
    { field: 'content', headerName: 'Content', flex: 1 },
    {
        field: 'user',
        headerName: 'Created By',
        width: 170,
        valueFormatter: (value: User) => {
            return value.fullName;
        },
    },
    {
        field: 'updatedAt',
        headerName: 'Updated At',
        width: 200,
        type: 'date',
        valueFormatter: (value: string) =>
            format(new Date(value), 'MM-dd-yyyy: hh:mm:ssa'),
    },
];

interface BusinessNotesProps {
    businessSignup: BusinessSignup;
    refetchData: () => void;
}

export function BusinessNotesCard({
    businessSignup,
    refetchData,
}: BusinessNotesProps) {
    const notifications = useNotifications();

    const formContext = useForm<BusinessSignupNote.CreateRequest>({
        resolver: yupResolver(NOTES_SCHEMA),
        defaultValues: {},
    });

    const mutateNotes = useMutation({
        mutationKey: ['businessSignupNote', businessSignup.id],
        mutationFn: (data: BusinessSignupNote.CreateRequest) => {
            return Api.Businesses.addNoteToSignup(
                Number(businessSignup.id),
                data
            );
        },
    });

    const handleAddNote = (values: BusinessSignupNote.CreateRequest) => {
        mutateNotes
            .mutateAsync(values)
            .then(() => {
                formContext.reset();
                refetchData();
            })
            .catch((error: Error) => {
                notifications.show(error.message, {
                    severity: 'error',
                });
            });
    };

    return (
        <Stack gap={3}>
            <DataGridCard title="Notes">
                <DataGrid
                    autoHeight
                    rows={businessSignup?.notes ?? []}
                    columns={columns}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    paginationMode="client"
                />
            </DataGridCard>
            <NotesForm onSubmit={handleAddNote} formContext={formContext} />
        </Stack>
    );
}
